<template>
	<div class="releaselog">
		<Nav></Nav>
		<div class="writing_right">
			<div class="TitleList">
				<div class="TitleList_padding">
					<div class="TitleList_top">
						<div class="TitleList_top_title"><span></span>搜索引擎推送日志</div>
						<div class="TitleList_top_txt">
							<div class="top_txt_list time">
								<el-date-picker v-model="params.time" type="daterange" align="right" unlink-panels
									format="yyyy-MM-dd" value-format="yyyy-MM-dd" range-separator="至"
									start-placeholder="开始日期" end-placeholder="结束日期">
								</el-date-picker>
							</div>
							<div class="top_txt_list">
								<el-select clearable v-model="params.push_plan_id" placeholder="所属计划">
									<el-option v-for="item in plans" :key="item.id" :label="item.name" :value="item.id">
									</el-option>
								</el-select>
							</div>
							<div class="top_txt_list">
								<el-select clearable v-model="params.site_id" placeholder="所属站点">
									<el-option v-for="item in sites" :key="item.id" :label="item.name" :value="item.id">
									</el-option>
								</el-select>
							</div>
							<div class="top_txt_list">
								<el-select clearable v-model="params.state" placeholder="推送状态">
									<el-option v-for="item in states" :key="item.id" :label="item.name"
										:value="item.id">
									</el-option>
								</el-select>
							</div>
							<div class="top_txt_list search">
								<el-input v-model="params.article_id" placeholder="文章ID"></el-input>
								<button @click="search">搜索</button>
							</div>
						</div>
					</div>
				</div>
				<div class="myarticles" v-loading="loading" element-loading-spinner="el-icon-loading"
					element-loading-text="拼命加载中" element-loading-background="rgba(255, 255, 255, 1)">
					<div class="myarticles_content creation">
						<div class="myarticles_content_title">
							<div class="content_title_list">序号</div>
							<div class="content_title_list">文章名称/链接</div>
							<div class="content_title_list">搜索引擎</div>
							<div class="content_title_list">分类</div>
							<div class="content_title_list">推送时间</div>
							<div class="content_title_list">站点</div>
							<div class="content_title_list">推送状态</div>
							<div class="content_title_list">所属计划</div>
							<div class="content_title_list">操作</div>
						</div>
						<div class="myarticles_content_tab">
							<div class="content_tab_list" :class="{ on: info.checked }"
								v-for="(info, index) in infos.data" :key="index">
								<div class="tab_list_li">{{ info.id }}</div>
								<div class="tab_list_li">{{ info.article_name }}<br><a :href="info.article_url" target="_blank">{{ info.article_url }}</a></div>
								<div class="tab_list_li">{{ info.webmaster_name }}</div>
								<div class="tab_list_li">{{ info.article_class_name }}</div>
								<div class="tab_list_li">{{ info.create_time }}</div>
								<div class="tab_list_li">{{ info.site_name }}</div>
								<div class="tab_list_li">
									<div class="list_li_state on" v-if="!info.status"><span></span>失败</div>
									<div class="list_li_state" v-if="info.status"><span></span>成功</div>
								</div>
								<div class="tab_list_li">{{ info.plan_name }}</div>
								<div class="tab_list_li operate">
									<div class="list_li_btn" @click="detail(index)"><img src="@a/img/sv9.svg" />查看</div>
								</div>
							</div>
							<div class="not_data not_data2" v-show="infos.data.length === 0">
								<div class="not_data_icon"><img src="@a/img/bg26.jpg" /></div>
								<div class="not_data_title">暂无发布日志</div>
							</div>
						</div>
					</div>
					<div class="page">
						<el-pagination @size-change="handleSizeChange" @current-change="handleCurrentChange"
							:current-page="infos.current_page" :page-sizes="per_pages" :page-size="infos.per_page"
							layout="total, sizes, prev, pager, next, jumper" :total="infos.total">
						</el-pagination>
					</div>
				</div>
			</div>
		</div>


		<!-- 日志 -->
		<div class="Preview Edit Log" v-show="showLog">
			<div class="Preview_content">
				<div class="Preview_content_title">
					<div class="content_title_left"><span></span>日志</div>
					<div class="content_title_right" @click="showLog = !showLog"><i class="el-icon-close"></i></div>
				</div>
				<div class="Edit_content">
					<div class="Edit_content_list">
						<div class="content_list_dd">日志ID</div>
						<div class="content_list_dt">{{ log.id }}</div>
					</div>
					<div class="Edit_content_list">
						<div class="content_list_dd">文章ID</div>
						<div class="content_list_dt">{{ log.article_id }}</div>
					</div>
					<div class="Edit_content_list">
						<div class="content_list_dd">标题</div>
						<div class="content_list_dt">{{ log.article_name }}</div>
					</div>
					<div class="Edit_content_list">
						<div class="content_list_dd">推送链接</div>
						<div class="content_list_dt"><a :href="log.article_url" target="_blank">{{log.article_url }}</a> </div>
					</div>										
					<div class="Edit_content_list">
						<div class="content_list_dd">分类</div>
						<div class="content_list_dt">{{ log.article_class_name }}</div>
					</div>
					<div class="Edit_content_list">
						<div class="content_list_dd">推送时间</div>
						<div class="content_list_dt">{{ log.create_time }}</div>
					</div>
					<div class="Edit_content_list">
						<div class="content_list_dd">推送搜索引擎</div>
						<div class="content_list_dt">{{ log.webmaster_name }}</div>
					</div>					
					<div class="Edit_content_list">
						<div class="content_list_dd">推送状态</div>
						<div class="content_list_dt"><span>{{ log.status ? '成功' : '失败' }}</span></div>
					</div>
					<div class="Edit_content_list">
						<div class="content_list_dd">所属计划</div>
						<div class="content_list_dt">{{ log.plan_name }}</div>
					</div>
					<div class="Edit_content_list">
						<div class="content_list_dd">站点</div>
						<div class="content_list_dt">{{ log.site_name }}</div>
					</div>
          <div class="Edit_content_list">
            <div class="content_list_dd">备注</div>
            <div class="content_list_dt">{{ log.remark ? log.remark : '-' }}</div>
          </div>
				</div>
			</div>
		</div>

	</div>
</template>

<script>
	import Nav from "@c/common/nav/nav";


	export default {
		name: "plantorelease",
		data() {
			return {
				showLog: false,
				log: {

				},
				states: [{
						id: 1,
						name: '推送成功',
					},
					{
						id: 0,
						name: '推送失败',
					},
				],
				sites: [],
				plans: [],
				isChecked: false,
				showPreview: false,
				infos: {
					data: [],
					per_page: 10,
					current_page: 1,
					last_page: 1,
					total: 0
				},
				params: {
					time: this.getTimeRange(this.$route.query.time),
					push_plan_id: this.$route.query.push_plan_id ? parseInt(this.$route.query.push_plan_id) : '',
					site_id: this.$route.query.site_id ? parseInt(this.$route.query.site_id) : '',
					state: '',
					article_id: ''
				},
				per_pages: [10, 20, 30],
        loading: true,
			};
		},
		components: {
			Nav
		},

		methods: {
			getTimeRange(timeQuery) {
			  // 创建一个 Date 对象
			  const date = new Date();

			  // 获取年份、月份、日期
			  const year = date.getFullYear();
			  const month = String(date.getMonth() + 1).padStart(2, '0');
			  const day = String(date.getDate()).padStart(2, '0');

			  // 将当前日期拼接为字符串
			  const today = `${year}-${month}-${day}`;

			  // 将昨天的日期计算出来
			  const yesterdayDate = new Date(date); // 克隆 Date 对象，避免修改原对象
			  yesterdayDate.setDate(yesterdayDate.getDate() - 1);
			  const yesterdayYear = yesterdayDate.getFullYear();
			  const yesterdayMonth = String(yesterdayDate.getMonth() + 1).padStart(2, '0');
			  const yesterdayDay = String(yesterdayDate.getDate()).padStart(2, '0');

			  // 将昨天的日期拼接为字符串
			  const yesterday = `${yesterdayYear}-${yesterdayMonth}-${yesterdayDay}`;

			  // 获取本月的第一天和最后一天
			  const firstDayOfThisMonth = `${year}-${month}-01`;
			  const lastDayOfThisMonth = `${year}-${month}-${new Date(year, parseInt(month), 0).getDate()}`;

			  // 获取上个月的年份和月份
			  let lastMonthYear = year;
			  let lastMonth = String(parseInt(month) - 1);
			  if (lastMonth === '0') {
				lastMonthYear = year - 1;
				lastMonth = '12';
			  } else {
				lastMonth = lastMonth.padStart(2, '0');
			  }

			  // 获取上个月的第一天和最后一天
			  const firstDayOfLastMonth = `${lastMonthYear}-${lastMonth}-01`;
			  const lastDayOfLastMonth = `${lastMonthYear}-${lastMonth}-${new Date(lastMonthYear, parseInt(lastMonth), 0).getDate()}`;				
			  switch (timeQuery) {
				case '1':
				  return [today, today];
				case '-1':
				  return [yesterday, yesterday];
				case 'current_month':
				  return [firstDayOfThisMonth, lastDayOfThisMonth];
				case 'last_month':
				  return [firstDayOfLastMonth, lastDayOfLastMonth];
				default:
				  return ['', ''];
			  }
			},			
			//点击触发ai套餐
			triggerChildMethod() {
			this.$refs.Nav.childMethod();
			},
			  search(){
				this.infos.current_page = 1;
				this.getList()
			  },
			detail(index) {
				this.log = this.infos.data[index];
				this.showLog = true;
			},
			handleSizeChange(val) {
				this.infos.per_page = val
				this.getList()
			},
			handleCurrentChange(val) {
				this.infos.current_page = val
				this.getList()

			},
			getList() {
				// loading 开始
				this.loading = true;
				let that = this;
				let this_params = JSON.parse(JSON.stringify(that.params));
				this_params.start = this_params.time[0]
				this_params.end = this_params.time[1]
				delete this_params.time;
				for (let i in this_params) {
					if (this_params[i] === '') {
						delete this_params[i];
					}
				}
				let params = {
					...this_params,
					page: that.infos.current_page,
					keywords: that.keywords,
					list_rows: that.infos.per_page,
					class_id: that.class_type,
				}

				that.axios.get('/api/WebmasterPushLog/list', {
					params
				}).then(res => {
					// loading结束
					this.loading = false;
					that.infos = res.result;
				})
			},
			getPlans() {
				let that = this;
				this.axios.get('/api/plan/list', {
					params: {
						list_rows: 999,
					}
				}).then(res => {
					that.plans = res.result.data
					that.params = JSON.parse(JSON.stringify(that.params))
				})
			},



			getSites() {
				let that = this;
				this.axios.get('/api/site/list').then(res => {

					that.sites = res.result.data
					that.params = JSON.parse(JSON.stringify(that.params))
				})
			},
		},
		created() {
			this.getSites()
			this.getPlans()
			this.getList()

		},
	}
</script>

<style>
	@import "webMasterPushLog.css";
</style>
